/**
 * Endpoints da API Admin
 */
export const ENDPOINTS = {
  // Autenticação Admin
  ADMIN_LOGIN: '/api/admin/login',

  // Dashboard
  ADMIN_DASHBOARD: '/api/admin/dashboard',

  // Usuários
  ADMIN_USERS: '/api/admin/users',
  ADMIN_USER_DETAIL: (id) => `/api/admin/users/${id}`,
  ADMIN_USER_STATUS: (id) => `/api/admin/users/${id}/status`,

  // Negócios
  ADMIN_ENTITIES: '/api/admin/entities',
  ADMIN_ENTITIES_STATS: '/api/admin/entities/stats',
  ADMIN_ENTITY_DETAIL: (id) => `/api/admin/entities/${id}`,
  ADMIN_ENTITY_STATUS: (id) => `/api/admin/entities/${id}/status`,

  // Planos
  ADMIN_PLANS: '/api/admin/plans',
  ADMIN_PLANS_STATS: '/api/admin/plans/stats',

  // Reviews
  ADMIN_REVIEWS: '/api/admin/reviews',
  ADMIN_REVIEWS_STATS: '/api/admin/reviews/stats',

  // Pets
  ADMIN_PETS_STATS: '/api/admin/pets/stats',
  ADMIN_PETS_HEALTH_ALERTS: '/api/admin/pets/health-alerts',

  // Agendamentos
  ADMIN_SCHEDULES: '/api/admin/schedules',
  ADMIN_SCHEDULES_STATS: '/api/admin/schedules/stats',
};

/**
 * Configuração da API
 */
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  TIMEOUT: 30000,
};
